<template>
  <ul class="list">
    <slot />
  </ul>
</template>

<style scoped lang="scss">
.list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
</style>